import ApiService from "@/core/services/api.service";

export const accountBase = {
    list: (id = null) => {
        return  ApiService.get("admin/user/detail-admin-user/"+id);
    },
    updateAdminUser: (data = null) => {
        return ApiService.post("admin/user/update-admin-user", data);
    }
}

export const list_account = {
    list: (data = null) => {
        const searchParams = new URLSearchParams();
        let params = data?data: {};
        Object.keys(params).forEach(key => searchParams.append(key, params[key]));
        return ApiService.get("admin/user/list-account?"+searchParams.toString());
    },
    getDataCsv:(data = null) => {
        const searchParams = new URLSearchParams();
        let params = data?data: {};
        Object.keys(params).forEach(key => searchParams.append(key, params[key]));
        return  ApiService.get("admin/user/export-excel?"+searchParams.toString());
    }
}
